import { render } from "./FloatPage.vue?vue&type=template&id=0385148a&ts=true"
import script from "./FloatPage.vue?vue&type=script&lang=ts"
export * from "./FloatPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__